module.exports = __webpack_public_path__ + "img/customers_say_02.e551dd3c.jpg";